import {TrackableEntity} from './data/ChangeTrackable';
import { IDictionary } from './data/TrackingModule';
import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';

export class OhContainer extends TrackableEntity {
    id: number = 0;
    hblId: number = 0;
    mCntId: number = 0;
    pkgs: number = 0;
    cbm: number = 0;
    cft: number = 0;
    kgs: number = 0;
    lbs: number = 0;
    amsLinkUserID: string = '';
    amsLinkId: number = 0;
    amsLinkDate: string | null = null;
    pimsLinkUserID: string = '';
    pimsLinkId: number = 0;
    pimsLinkDate: string | null = null;
    containerNo: string = '';
    conType: string = '';
    sealNo: string = '';
    mPkgs: number = 0;
    mUnit: string = '';
    agentShow: boolean = false;
    oihBlId: number = 0;
    oimCntID: number = 0;
    // UI
    select: boolean = false;

    constructor(init?:Partial<OhContainer>) {
        super();
        this.key='id';
        Object.assign(this, init);
        this.noTrackProps.push('id', 'containerNo', 'conType', 'sealNo', 'mPkgs', 'mUnit', 'agentShow', 'oihBlId', 'oimCntID');
        if(this.id === 0) this.id = this.GetNextId();
    }

    getDbMappings(arg?:any):IDictionary<DBMappingInfo> {
        return OhContainer.dicFieldMappings;
    }

    static dicFieldMappings:IDictionary<DBMappingInfo> = {
        'id': new DBMappingInfo({ field: 'F_Id', table: 'T_OOHCONTAINER' }),
        'mCntId': new DBMappingInfo({ field: 'F_OOMCNTID', table: 'T_OOHCONTAINER' }),
        'pkgs': new DBMappingInfo({ field: 'F_PKGS', table: 'T_OOHCONTAINER' }),
        'hblId': new DBMappingInfo({ field: 'F_OOHBLID', table: 'T_OOHCONTAINER' }),
    };

    static dicFieldMappings1:IDictionary<DBMappingInfo> = {
        'id': new DBMappingInfo({ field: 'F_Id', table: 'T_OIHCONTAINER' }),
        'mCntId': new DBMappingInfo({ field: 'F_OIMCNTID', table: 'T_OIHCONTAINER' }),
        'pkgs': new DBMappingInfo({ field: 'F_PKGS', table: 'T_OIHCONTAINER' }),
        'hblId': new DBMappingInfo({ field: 'F_OIHBLID', table: 'T_OIHCONTAINER' }),
    };
    
}
